<template>
  <div class="all-table" v-loading="loading">
    <div class="all-option">
    	<div class="all-option-one">
    		<ul class="clearfix">
    			<li v-for="(item,index) in category" :key="index"><a @click="chooseCategory(item)" href="javascript:;" :class="{'option-one-state':item.id==category1}">{{item.categoryName}}</a></li>
    		</ul>
    	</div>
    	<div class="all-option-two" v-show="categoryChild.length > 0">
    		<ul class="clearfix">
          <li v-for="(item,index) in categoryChild" :key="index">
            <a @click="chooseCategoryChild(item)" href="javascript:;" :class="{'option-two-state':item.id==category2}">{{item.categoryName}}</a>
          </li>
    		</ul>
    	</div>
    </div>

    <div >
        <CourseList :frompage="frompage" @pagechange="pagechange" :total="total" :list="courselist"></CourseList>
    </div>
  </div>
</template>

<script>
import '../../assets/css/allcourse.css'
import {ApiGetBookCategory,ApiGetBookCourse} from '../../net/course/index.js'
import CourseList from './child/courseList.vue'
export default {
  data: function () {
    return {
      str: '所有课程',
      category : [],
      categoryChild : [],
      courselist :[],
      params : {},
      loading : false,
      item : {id : 0},
      clicktype : 0,
      total : 20,
      pageNum : 1,
      frompage : 'BookCourse',
      category1: 0, //当前一级分类id
      category2: 0, //当前二级分类id
    }
  },
  components: {
    CourseList
  },

  methods:{
    getgory(){
      ApiGetBookCategory({pid: 0}).then(res=>{
        if(res.code == 200){
          this.category = res.value
        }
        this.loading = false
      })
    },
    getgory2 (pid) {
      if (pid == 0) {
        this.getCourse(1)
        return
      }
      ApiGetBookCategory({pid: pid}).then(res=>{
        if(res.code == 200){
          this.categoryChild = res.value
          this.getCourse(1)
        }
        this.loading = false
      })

    },
    chooseCategory(item){
      if (this.category1 == item.id) {return}
      this.category1 = item.id
      this.category2 = 0
      this.getgory2(item.id)
    },
    chooseCategoryChild(item){
      if (this.category2 == item.id) {return}
      this.category2 = item.id
      this.getCourse(1)
    },
    getCourse(index){
      this.loading = true
      let params= {
        // categoryId : this.category1,
        pageNum : index,
        pageSize : 20
      }
      if (this.category1 != 0) {
         params.categoryId = this.category1
      }
      if (this.category2 != 0) {
        params.detailId = this.category2
      }
      ApiGetBookCourse(params).then(res=>{
        if(res.code == 200){
          this.total = res.value.total
          this.courselist = res.value.list
        }
        this.loading = false
      })
    },
    pagechange(index){
      this.getCourse(index);
    }
  },
  mounted() {
    this.getgory();
    this.getCourse(1)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BookCourse/BookCourse.vue